export default __webpack_public_path__ + "static/media/pad-thai.9ab8a0b4.png";